import {
  Button,
  Divider,
  IconButton,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import { UserPicker } from '@work4all/components/lib/components/entity-picker/user-picker/UserPicker';
import { HookedUserIcon } from '@work4all/components/lib/components/user-icon/useUserIconRegister';

import { User } from '@work4all/models/lib/Classes/User.entity';

type UserButtonProps = {
  currentUser: User;
  selectedUser: User;
  locked?: boolean;
  onUserChange: (user: User) => void;
};

export const UserButton = (props: UserButtonProps) => {
  const { currentUser, selectedUser, locked, onUserChange } = props;

  const { t } = useTranslation();

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );

  return (
    <>
      <EntityPickerPopover
        picker={
          <UserPicker
            value={selectedUser}
            onChange={onUserChange}
            multiple={false}
            clearable={false}
          />
        }
      >
        {isMobile ? (
          <IconButton
            style={{ pointerEvents: locked ? 'none' : 'auto' }}
            tabIndex={-1}
          >
            <HookedUserIcon userId={selectedUser.id} />
          </IconButton>
        ) : (
          <Button
            startIcon={<HookedUserIcon userId={selectedUser.id} />}
            style={{ pointerEvents: locked ? 'none' : 'auto' }}
            tabIndex={-1}
          >
            <Typography>{selectedUser?.displayName}</Typography>
          </Button>
        )}
      </EntityPickerPopover>
      {currentUser.id !== selectedUser.id && (
        <Stack flexDirection="row">
          <Divider orientation="vertical" variant="middle" flexItem />
          <Button variant="text" onClick={() => onUserChange(currentUser)}>
            {t('CALENDAR.VIEWS.MY_APPOINTMENTS')}
          </Button>
        </Stack>
      )}
    </>
  );
};
